import React from 'react';


const TemplateCard = ({ title, colors, selected, onClicked }) => (
    <div
        style={{
            border: selected ? '1px solid #3B82F6' : '1px solid #E0E0E0',
            borderRadius: '5px',
            width: '120px',
            height: '100px',
            margin: '15px 20px 10px 0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            overflow: 'hidden',
            cursor: 'pointer'
        }}
        onClick={onClicked}
    >
        <div style={{ fontSize: '13px', fontWeight: '500', marginTop: '10px', marginLeft: '8px', marginRight: '8px', lineHeight: '1rem' }}>
            {title}
        </div>
        <div style={{ display: 'flex', marginTop: 'auto' }}>
            {colors.map((color, index) => (
                <div
                    key={index}
                    style={{
                        flex: 1,
                        backgroundColor: color,
                        height: '30px',
                    }}
                />
            ))}
        </div>
    </div>
);

export default TemplateCard;